// src/components/Layout.js
import React from 'react';
import { Outlet, useLocation, NavLink, Link } from 'react-router-dom';
import { navConfig } from '../config/navigation';

const AppHeader = () => (
    <Link to="/" className="app-header-link">
        <header className="app-header">
            <img src="/logo-img.png" alt="logo" className="logo-img" />
            <span className="app-name">꿀단지개미 </span>
            {/* <img
                src="/walking-ant.gif"
                className="header-video"
                alt="Walking Ant"
            /> */}
        </header>
    </Link>
);

const TopNav = () => {
    const { pathname } = useLocation();
    return (
        <nav className="top-nav">
            {Object.values(navConfig).map((item) => (
                <NavLink
                    key={item.base}
                    to={item.links[0].to}
                    className={`top-nav-link ${pathname.startsWith(item.base) ? 'active' : ''}`}
                >
                    {item.name}
                </NavLink>
            ))}
        </nav>
    );
};

const SubNav = () => {
    const { pathname } = useLocation();
    const activeTopNav = Object.values(navConfig).find(item => pathname.startsWith(item.base));
    if (!activeTopNav) return null;
    return (
        <nav className="sub-nav">
            {activeTopNav.links.map(link => (
                <NavLink key={link.to} to={link.to} className="sub-nav-link">
                    {link.name}
                </NavLink>
            ))}
        </nav>
    );
};

const Layout = () => {
    return (
        <>
            <AppHeader />
            <div className="nav-container">
                <TopNav />
                <SubNav />
            </div>
            <main className="page-content">
                <Outlet />
            </main>
        </>
    );
};

export default Layout;